import { useState, useCallback, ReactNode } from 'react';
import { SideNav } from './SideNav';
import { TopBar } from './TopBar';
import { ImpersonationBanner } from '../ImpersonationBanner';

interface AppShellProps {
  children: ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  const handleMenuClick = useCallback(() => {
    setIsMobileNavOpen(true);
  }, []);

  const handleNavClose = useCallback(() => {
    setIsMobileNavOpen(false);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Impersonation banner at the very top */}
      <ImpersonationBanner />

      {/* Side navigation */}
      <SideNav isOpen={isMobileNavOpen} onClose={handleNavClose} />

      {/* Top bar for mobile only */}
      <TopBar onMenuClick={handleMenuClick} />

      {/* Main content area - offset on desktop to account for sidebar */}
      {/* DRAWER_WIDTH = 260px, using md:ml-[260px] */}
      <main className="px-4 py-6 md:py-8 md:px-6 md:ml-[260px]">
        <div className="max-w-7xl mx-auto">
          {children}
        </div>
      </main>
    </div>
  );
}
